const globalVariables = {
    WEB_ADDRESS_PORT: "https://e627-2001-fd8-f09e-70dd-8d31-1406-bf69-6efa.ngrok-free.app"
    //WEB_ADDRESS_PORT: "http://localhost:3500"
}

export default globalVariables;